"use client";

import styled from "styled-components";
import Icon from "../icon";

interface ButtonProps {
  $widthFull?: boolean;
  $variant?: "default" | "danger" | "warning" | "success" | undefined;
  $small?: boolean;
}

const variantStyles = {
  default: `
        background: transparent;
        color: var(--textLight);
        border: 1px solid var(--textLight);

        &:hover {
            background: rgba(75, 85, 99, 0.1);
        }
    `,
  danger: `
        background: var(--red);
        color: var(--white);

        &:hover {
            background: #bb1b1f;
        }
    `,
  warning: `
        background: var(--infoSystem);
        color: var(--colorTitle);

        &:hover {
            background: #ffd000;
        }
    `,
  success: `
        background: var(--primarySystem100);
        color: var(--white);

        &:hover {
        background: var(--primarySystem100);
        }
    `,
};

export const DropdownButton = styled.button<ButtonProps>`
  padding: 9px;
  border-radius: 5px;
  font-family: "Roboto Medium";
  font-size: 14px;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  ${({ $variant = "default" }) => variantStyles[$variant]}

  &:hover {
  }

  svg {
    width: 20px;
  }
`;

export const DropdownTitle = styled.h4`
  font-family: "Roboto Medium";
  color: var(--colorTitle);
  padding: calc(0.25rem * 2);
`;

export const DropdownContent = styled.div``;

export const DropdownItem = styled.div`
  padding: calc(0.25rem * 1.5) calc(0.25rem * 2);
  font-family: "Roboto Light";
  font-size: 14px;
  color: var(--colorText);
  cursor: pointer;
  border-radius: 5px;
  &:hover {
    background: var(--hoverDropdownItem);
    color: #fff;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const Dropdown = styled.div<{ $open?: boolean }>`
  position: absolute;
  top: 100%;
  right: 0;
  border: 1px solid #ccc;
  z-index: 1;
  display: ${({ $open }) => ($open ? "block" : "none")};
  visibility: ${({ $open }) => ($open ? "visible" : "hidden")};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transition: 0.2s ease-in-out;
  background: var(--backgroundColor);
  border: 1px solid var(--border);
  border-radius: 5px;
  padding: calc(0.25rem * 1);
  min-width: 100%;
  width: 100%;
`;

export const DropdownBox = styled.div`
  position: relative;
  width: fit-content;
  width: 100%;
`;

export const IconComponent = styled(Icon)`
  svg {
    max-width: 20px !important;
    max-height: 20px !important;

    path {
      fill: var(--titleColor);
    }
  }
`;
